import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NgIconWrapperComponent } from '../../../../../components/icons/ng-icon-wrapper/ng-icon-wrapper.component';
import { TailwindButtonDirective } from '../../../../../components/button/tailwind-button.directive';
import { FormatWorkPipe } from '../../../../../pipes/format-work.pipe';
import { Position2 } from '@jessie/commons';
import { FormatAmount } from '../../../../../pipes/format-amount';
import { FavoriteComponent } from '../../../../../components/favorite/favorite.component';

@Component({
    selector: 'app-position-card',
    templateUrl: './position-card.component.html',
    imports: [NgIconWrapperComponent, TailwindButtonDirective, FormatWorkPipe, FormatAmount, FavoriteComponent]
})
export class PositionCardComponent {
  @Input() position!: Position2;
  @Input() userId: string | null = null;

  @Output() modifyPosition = new EventEmitter<Position2>();
  @Output() createWork = new EventEmitter<Position2>();
  @Output() showWork = new EventEmitter<Position2>();
  @Output() favoriteChanged = new EventEmitter<boolean>();
}
